/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyersstylecolor3Inputs */

const en_placeflyersstylecolor3 = /** @type {(inputs: Placeflyersstylecolor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour`)
};

const de_placeflyersstylecolor3 = /** @type {(inputs: Placeflyersstylecolor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbig`)
};

/**
* | output |
* | --- |
* | "Colour" |
*
* @param {Placeflyersstylecolor3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersstylecolor3 = /** @type {((inputs?: Placeflyersstylecolor3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersstylecolor3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersstylecolor3(inputs)
	return de_placeflyersstylecolor3(inputs)
});
export { placeflyersstylecolor3 as "placeFlyersStyleColor" }